import { useModal } from "@ebay/nice-modal-react";
import AddIcon from "@mui/icons-material/Add";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";
import TypesenseInstantSearch, {
  TypesenseContext,
} from "components/context/TypesenseInstantSearch";
import { UserContext } from "components/context/UserProvider";
import useQueryStringState from "components/hooks/useQueryStringState";
import useInstantSearchConfig from "components/shared/useInstantSearchConfig";
import Button, {
  TypesenseInfiniteScrollButton,
} from "components/ui/atoms/Button";
import NoteHits from "components/ui/atoms/ConnectHits/NoteHits";
import Highlight from "components/ui/atoms/Highlight";
import FilterAndSort from "components/ui/molecules/FilterAndSort";
import Layout from "components/ui/molecules/Layout";
import NoteFilterForm from "models/notes/NoteFilterForm";
import NoteSortForm from "models/notes/NoteSortForm";
import { useContext, useEffect, useState } from "react";
import { useInfiniteHits } from "react-instantsearch";

const InnerNote = ({ clearTypesensCache }) => {
  const theme = useTheme();
  const [state, setState] = useQueryStringState();
  const { user } = useContext(UserContext);
  const { typesenseEnv } = useContext(TypesenseContext);
  const { applyState } = useInstantSearchConfig({
    sortBy: [{ value: `${typesenseEnv}_note`, label: "Note" }],
    refinements: [
      {
        refinementType: "list",
        refinementName: "owner_id_facet",
        filterName: "owner",
      },
    ],
  });
  const { hits, hasMore, refineNext, results } = useInfiniteHits();
  const noteModal = useModal("NoteDrawer");

  useEffect(() => {
    applyState(state);
  }, [state]);

  return (
    <Layout container hideBreadcrumbs>
      <Layout title variant="component">
        <Grid container spacing={2} alignItems="center" sx={{ width: "100%" }}>
          <Grid>
            <Highlight color={theme.palette_custom.lightGreen}>Note</Highlight>
          </Grid>
          <Grid ml="auto">
            <Button
              endIcon={
                <AddIcon sx={{ transform: "rotate(90deg)", scale: "0.8" }} />
              }
              onClick={() =>
                noteModal
                  .show({
                    formType: "create",
                    initialValues: {
                      owner: user.id,
                      owner_detail: user,
                      people: [],
                      people_ids: [],
                    },
                  })
                  .then(() => clearTypesensCache())
              }
            >
              Create
            </Button>
          </Grid>
        </Grid>
      </Layout>
      <Layout content>
        <FilterAndSort
          FilterForm={NoteFilterForm}
          SortForm={NoteSortForm}
          state={state}
          setState={setState}
          count={results?.nbHits}
        />
      </Layout>
      <Layout content>
        <NoteHits
          hits={hits}
          hasMore={hasMore}
          refineNext={refineNext}
          onClick={(id) =>
            noteModal
              .show({
                formType: "update",
                id,
              })
              .then(() => clearTypesensCache())
          }
        />
        <TypesenseInfiniteScrollButton />
      </Layout>
    </Layout>
  );
};

const Note = () => {
  const searchClient = useContext(TypesenseContext);
  const [key, setKey] = useState(0);

  //key is the only simple way to refresh infinitHits state contained in InnerNote
  const refresh = () => {
    searchClient.clearCache();
    setKey(key + 1);
  };

  return (
    <TypesenseInstantSearch indexName="note">
      <InnerNote key={key} clearTypesensCache={refresh} />
    </TypesenseInstantSearch>
  );
};

export default Note;
